<template>
  <d2-container>
    <top-line :message="pageTitle" :iconclass="'fa fa-users'"></top-line>
    <el-row class="pagebody">
      <!--el-row class="filter-bar">
        <el-card shadow="never">
          <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="200px" size="small">
            <el-row >
              <el-col :span="6"><el-form-item label="时间范围：" class="search-item" :label-width="labelWidth">
                    <el-date-picker
                      v-model="searchForm.month"
                      type="month"
                      placeholder="选择月" style="width:175px" @change="handleSearch" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="用户：" prop="username" class="search-item" :label-width="labelWidth">
                  <el-input v-model="searchForm.username" style="width:175px" />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-button type="primary" icon="el-icon-search" size="small" plain style="margin-left:8px;"
                           class="fr"
                           @click="handleSearch">
                  查询
                </el-button>
                <el-button type="info" icon="el-icon-refresh-left" size="small" plain style="margin-left:8px;"
                           class="fr"
                           @click="handleReset">
                  重置
                </el-button>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </el-row>-->

      <el-row class="main-table">
        <el-table :data="tableData" border stripe>
          <el-table-column type="index" align="center" width="75px" />
          <el-table-column prop="namespace" label="用户" width="160px" />
          <el-table-column prop="month" label="月份"  width="200px"/>
          <el-table-column label="计费（元）" width="200px">
            <template slot-scope="scope">
              {{ parseFloat(scope.row.cost).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column prop="gpuModel" label="操作" align="center"  width="160px">
            <template v-slot="scope">
              <el-button type="text" size="mini" @click="showDetail(scope.row)">自然日账单</el-button>
            </template>
          </el-table-column>

        </el-table>
      </el-row>
      <el-row type="flex" justify="left" style="margin-top: 10px; margin-bottom: 18px;">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="pagination.page"
            :page-sizes="pagination.pageSizeList"
            :page-size="pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total">
        </el-pagination>
      </el-row>
    </el-row>
  </d2-container>
</template>

<script>

import topLine from "@/components/save-common/topLine.vue";
import commonListMixin from "@/pages/mixin/mixin-common-list";

export default {
  name: "allns",
  mixins: [
    commonListMixin // 假设 commonListMixin 包含 getTableData 方法
  ],
  components: {
    topLine,
  },
  watch: {
    $route: {
      handler(newRoute) {
        this.loadParams(); // 接收并解析 URL 参数
        this.getTableData(); // 重新加载表格数据
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      pageTitle: "月账单列表",
      labelWidth: '120px',
      tableDataApi: '/api/user-month-billing',

      searchForm: {
        username:'',
        month: '', // 使用 YYYY-MM 格式的字符串
        gpuModel: '',
      },
      period: [],
      currentRow: {},
      loading: false, // 添加加载状态
    }
  },
  mounted () {
    this.initDate();
    this.loadParams();
    this.getTableData();
  },
  methods: {
    initDate() {
      this.searchForm.month = ''; // 初始化为空
      this.getTableData(); // 加载数据
    },
  
    handleReset () {
      this.searchForm = {
        username:'',
        month: '', // 清空月份
        gpuModel: '',
      };
      this.initDate(); // 重置为当前月份
      this.getTableData()
    },
    handleSearch () {
      // 如果 month 为空，则设置为当前月份
      // if (!this.searchForm.month) {
      //   this.searchForm.month = this.formatMonth(new Date());
      //   this.$message.info('未选择月份，默认使用当前月份进行查询');
      // }
      this.getTableData(); // 使用当前的 searchForm 进行搜索
    },

    // 格式化日期为 YYYY-MM-DD
      formatDate(date) {
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
      },

      // 获取某个月份的开始和结束日期
      getMonthRange(monthStr) {
        const [year, month] = monthStr.split('-').map(Number);
        const start = new Date(year, month - 1, 1); // 月份从0开始
        const end = new Date(year, month, 0);       // 下个月第0天即本月最后一天
        return {
          start_time: this.formatDate(start),
          end_time: this.formatDate(end)
        };
      },

      // 点击详情跳转
      showDetail(row) {
        console.log(row);
        const { start_time, end_time } = this.getMonthRange(row.month);
        this.$router.push({
          path: '/user-billing-day', // 请确认路径是否匹配您的路由
          query: {
            username: row.namespace,
            month: row.month,
            start_time,
            end_time,
            orgPage: this.pagination.page,
            orgPageSize: this.pagination.pageSize,
            orgTotal: this.pagination.total,
          }
        });
      },

      loadParams() {
        const query = this.$route.query;
        if (query.username) this.searchForm.username = query.username;
        if (query.month) this.searchForm.month = query.month;
        if (query.start_time) this.searchForm.start_time = query.start_time;
        if (query.end_time) this.searchForm.end_time = query.end_time;
        if (query.page) this.pagination.page = parseInt(query.page, 10);
        if (query.pageSize) this.pagination.pageSize = parseInt(query.pageSize, 10);
        if (query.total) this.pagination.total = parseInt(query.total, 10);
      },

  
    
  }
}
</script>

<style scoped lang="scss">
.pagebody {
  margin-top: 20px;
  margin-left: 20px;
}
.filter-bar {
  margin-bottom: 10px;
}
.main-table {
  margin-top: 10px;
}

.search-button-line {
  display: flex;
  justify-content: flex-end;
}
.batch-button {
  min-width: 95px;
}
</style>
